<template>
    <div class="container">
        <div class="alert alert-warning" v-if="noJiraReference" role="alert">
            This task is NOT referenced to a Jira task. Please check at
            <a :href="this.$appConfig.SONNEN_JIRA_PROJECT" class="alert-link">VPPp Jira project</a>
        </div>
        <div class="alert alert-warning" v-if="this.$appConfig.debug" role="alert">
            Debug mode enabled. No persistent changes in SalesForce
        </div>
        <div class="alert alert-success" v-if="isFinished && !updateError" role="alert">Data sent to Salesforce</div>
        <div class="alert alert-danger" v-if="updateError" role="alert">Data NOT sent to Salesforce</div>

        <div class="container-lg" v-if="!status_error">
            <div class="row row-cols-auto mb-5 border border-secondary">
                <div class="col-8">
                    <div class="container">
                        <div class="row align-items-start">
                            <div class="col">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item">
                                        Tariff version: <b>{{ tariff }}</b>
                                    </li>
                                    <li class="list-group-item">
                                        Meter Installation:
                                        <a target="_blank" :href="`${sf_mi_link}`" class="link-primary">
                                            {{ sf_mi }}
                                            <img
                                                src="@/assets/salesforce-logo.png"
                                                width="48px"
                                                class="img-responsive"
                                                alt="Responsive image"
                                        /></a>
                                    </li>
                                    <li class="list-group-item">
                                        Service Partner:
                                        <a target="_blank" :href="`${service_partner_link}`" class="link-primary"
                                            >{{ service_partner }}
                                            <img
                                                src="@/assets/salesforce-logo.png"
                                                width="48px"
                                                class="img-responsive"
                                                alt="Responsive image"
                                        /></a>
                                    </li>
                                    <li class="list-group-item">
                                        Contract status:
                                        <b>{{ contract_status }}</b>
                                    </li>
                                    <li class="list-group-item">
                                        VPP category: <b>{{ vpp_category }}</b>
                                    </li>
                                    <li class="list-group-item">
                                        Status meter change:
                                        <b>{{ status_meter_change }}</b>
                                    </li>
                                    <li class="list-group-item">
                                        Metering concept capable:
                                        <b>{{ metering_concept_capable }}</b>
                                    </li>
                                </ul>
                            </div>
                            <div class="col">
                                <ul class="list-group list-group-flush">
                                    <li v-if="jira_task" class="list-group-item">
                                        <a target="_blank" :href="`${jira_task_link}`" class="link-primary">
                                            {{ jira_task }} &nbsp;
                                            <img
                                                src="@/assets/jira_icon.png"
                                                width="24px"
                                                class="img-responsive"
                                                alt="Responsive image"
                                        /></a>
                                    </li>
                                    <li class="list-group-item">
                                        Asset created:
                                        <b>{{ asset_created }}</b>
                                    </li>
                                    <div class="container">
                                        <div><b>necessary Actions:</b></div>
                                        <div class="form-check form-switch"><a href="#meter">Check meter</a></div>
                                        <div class="form-check form-switch"><a href="#lan">Check LAN connectifity</a></div>
                                        <div class="form-check form-switch"><a href="#lte">Check LTE connectifity</a></div>
                                        <div class="form-check form-switch">
                                            <a href="#connectivity">Check Meter connectifity</a>
                                        </div>
                                    </div>
                                </ul>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item">
                                        Installer mail communication:
                                        <b-input-group-prepend is-text>
                                            <b-icon
                                                icon="envelope"
                                                v-b-modal="'myModal_mails'"
                                                size="sm"
                                                variant="outline-primary"
                                                disabled
                                            ></b-icon>
                                            <div class="mx-auto" style="width: 200px">Show DSO mail communication</div>
                                        </b-input-group-prepend>
                                        <b-modal size="lg" v-bind:id="'myModal_mails'">
                                            <p class="my-4">bla</p>
                                        </b-modal>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <a name="commentField">
                        <div class="v-select vs--single">
                            <v-select
                                class="style-chooser_comment"
                                placeholder="Choose comment template"
                                :options="commentTypes"
                                :value="selectedCommentTemplate"
                                :dropdown-should-open="dropdownShouldOpen_CommentType"
                                @input="(commentType) => updateCommentType(commentType)"
                            >
                            </v-select>
                        </div>
                        <div class="mb-3 p-1">
                            <label for="exampleFormControlTextarea1" class="form-label"
                                ><i>Rückfrage zu ZV oder interner Kommentar</i></label
                            >
                            <textarea v-model="meterPreparationComment" class="form-control" rows="2"></textarea>
                        </div>
                        <div class="mb-3 p-1">
                            <label for="exampleFormControlTextarea1" class="form-label"><i>Hinweis für MSB</i></label>
                            <textarea v-model="commentForMSB" class="form-control" rows="2"></textarea>
                        </div>
                        <div class="bg-light clearfix">
                            <span>Please proceed to send information to Salesforce.</span>
                            <div class="mt-sm-4" />

                            <button type="button" class="btn btn-primary float-end" v-on:click="submitData">Submit</button>
                        </div>
                    </a>
                </div>
            </div>
            <div><h2>Meter documentation</h2></div>
            <b-row class="mb-3 row">
                <b-col
                    ><a name="meter">
                        <DocumentComponent
                            document-title="Cabinet"
                            :show_resource="show_cabinet"
                            doc-type="img"
                            modal-id="cabinetModal"
                            :getResources="getCabinetResources"
                        ></DocumentComponent>
                    </a>
                    <div class="form-check form-switch">
                        <input
                            v-model="meter_ok"
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckDefault"
                        />
                        <label class="form-check-label" for="flexSwitchCheckDefault">Meter OK</label>
                    </div>
                    <div class="container">
                        <b-row>
                            <div class="v-select vs--single">
                                <b>fastening type Z1</b>
                                <div class="container">
                                    <vue-picker
                                        class="fastening__picker"
                                        v-model="selectedFasteningType_Z1"
                                        autofocus
                                        placeholder="Choose a fastening type for Z1"
                                    >
                                        <vue-picker-option
                                            :key="fasteningType"
                                            v-for="fasteningType in fasteningTypeZ1"
                                            :value="fasteningType"
                                            >{{ fasteningType }}</vue-picker-option
                                        >
                                    </vue-picker>
                                </div>
                            </div>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mb-4 row">
                <b-col class="col-xs-6">
                    <a name="lan">
                        <DocumentComponent
                            document-title="LAN connectivity"
                            :show_resource="show_cabinet"
                            doc-type="img"
                            modal-id="LanModal"
                            :getResources="getLanResources"
                        ></DocumentComponent>
                    </a>

                    <div class="v-select vs--single">
                        <b>Preparation of LAN connection for meter</b>
                        <div class="container">
                            <vue-picker
                                class="lan__picker"
                                v-model="selectedLanConnection"
                                autofocus
                                placeholder="please select..."
                            >
                                <vue-picker-option :key="conn" v-for="conn in lanConnections" :value="conn">{{
                                    conn
                                }}</vue-picker-option>
                            </vue-picker>
                        </div>
                    </div>
                </b-col>
                <b-col class="col-xs-6">
                    <a name="lte">
                        <DocumentComponent
                            document-title="LTE connectivity"
                            doc-type="img"
                            modal-id="LteModal"
                            :getResources="getLteResources"
                        ></DocumentComponent
                    ></a>
                    <div class="v-select vs--single">
                        <b>Meter connection via LTE-Network</b>
                        <div class="container">
                            <vue-picker
                                class="lan__picker"
                                v-model="selectedLteConnection"
                                autofocus
                                placeholder="Choose LTE connection type"
                            >
                                <vue-picker-option :key="conn" v-for="conn in lteConnections" :value="conn">{{
                                    conn
                                }}</vue-picker-option>
                            </vue-picker>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mb-2 row">
                <h2>Meter connectivity</h2>
                <a name="connectivity">
                    <div class="row row-cols-auto mb-1 border border-secondary">
                        <div class="col-12">
                            <div class="container">
                                <div class="row align-items-start">
                                    <div class="col">
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item">
                                                <div class="form-check form-switch">
                                                    <input
                                                        v-model="meterConnection_ok"
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        role="switch"
                                                        id="flexSwitchCheckDefault"
                                                    />
                                                    <label class="form-check-label" for="flexSwitchCheckDefault">
                                                        <div :style="{ color: '#' + meterConnectionColor }">
                                                            Meter connection OK
                                                        </div>
                                                    </label>
                                                </div>
                                            </li>
                                            <li class="list-group-item">
                                                <div :style="{ color: '#' + signalQualityColor }">
                                                    Signal strength in (dBm):
                                                    <input size="sm" v-model="signalToStrength_DB" placeholder="---" />
                                                </div>
                                            </li>
                                            <li class="list-group-item">
                                                <div :style="{ color: '#' + downloadSpeedColor }">
                                                    Download speed (MBit/sec):
                                                    <input v-model="download_speed_mb_sec" placeholder="---" />
                                                </div>
                                            </li>
                                            <li class="list-group-item">
                                                <div :style="{ color: '#' + pingTimeColor }">
                                                    Ping time (msec): <input v-model="ping_ms" placeholder="---" />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col">
                                        <ul class="list-group list-group-flush">
                                            <div class="container">
                                                <div><b>necessary Actions:</b></div>
                                                <div class="form-check form-switch">
                                                    <a href="#commentField">Add comment</a>
                                                </div>
                                                <div class="form-check form-switch">
                                                    <a href="#commentField">Submit meter check</a>
                                                </div>
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </b-row>
        </div>
        <div v-else>
            <h2>Error</h2>
            An error occured during app execution. Please repeat action and in case of a further error message, report bug at xxx.
            Please provide the URL and the following error information with the bug report.
            <div class="mt-xl-4" />

            <h5>Error information</h5>

            <blockquote class="blockquote">
                <p class="mt-md-4">
                    Error: {{ status_error }}; Error message:
                    {{ error_message }}
                </p>
            </blockquote>
        </div>
    </div>
</template>

<script>
import DocumentComponent from "@/components/Document.vue";
import moment from "moment";

import {
    _fasteningType_Z1,
    _commentTypes_direct,
    changeTaskState,
    changeTaskDueDate,
    changeTaskOperator,
    _lanConnections,
    _lteConnections,
    updateSalesforceObject
} from "./meter_general.js";

export default {
    async mounted() {
        console.log("Meter Component mounted.");
        if (this.jira_task && this.$session.exists()) {
            this.noJiraReference = false;
            // start task and update jira task state
            await changeTaskState(this.jira_task, "execute", this.$session.get("username"), this.$appConfig);
            await changeTaskOperator(this.jira_task, this.$session.get("email"), this.$session.get("username"), this.$appConfig);
        }
    },
    name: "MeterView",
    data() {
        return {
            noJiraReference: true,
            isFinished: false,
            updateError: false,
            jira_task: this.$route.query.jira_task,
            old_action_data: {
                meter_ok: false,
                mi_comment: "",
                selectedFasteningType_Z1: "",
                selectedLanConnection: "",
                selectedLteConnection: ""
            },
            show_cabinet: true,
            status_error: false,
            error_message: "",
            selectedFasteningType_Z1: "--None--",
            selectedCommentTemplate: "--None--",
            selectedLanConnection: "None",
            selectedLteConnection: "Not possible",
            meterPreparationComment: "",
            commentForMSB: "",
            meter_ok: false,
            tariff: "FlatX",
            sf_mi: "MI-XXX",
            sf_mi_link: "https://sonnen.lightning.force.com/lightning/r/MeterInstallation__c/a1Z1o00000CrkkkEAB/view",
            service_partner_link: "https://sonnen.lightning.force.com/lightning/r/Account/0012400000YLHU0/view",
            service_partner: "ZEO Solar GmbH & Co. KG",
            contract_status: "Activated",
            vpp_category: "VPP fit",
            cabinet_image: [],
            circuit_resource: [],
            status_meter_change: "...",
            metering_concept_capable: "...",
            asset_created: "",
            fertigmeldung_resource: [],
            lan_resources: [],
            connectivity_resource: [],
            signalToStrength_DB: -999,
            ping_ms: 9999,
            download_speed_mb_sec: 0.0,
            meterConnection_ok: false,
            jira_task_link: "https://sonnen2020.atlassian.net/browse/undefined",
            meterConnectionColor: "ff00af",
            downloadSpeedColor: "ff00ff",
            pingTimeColor: "ff00ff",
            signalQualityColor: "ff00ff"
        };
    },
    props: ["productTariff", "componentData"],
    components: {
        DocumentComponent
    },
    created() {
        var self = this;
        const mi_identifier = this.$route.params.id.toUpperCase();
        console.log("Creating resources", mi_identifier);
        self.meterConnectionColor = this.calcMeterConnectionColor(this.componentData.meterConnection_ok);
        self.downloadSpeedColor = this.calcDownloadSpeedColor(this.componentData.download_speed_mb_sec);
        self.pingTimeColor = this.calcPingColor(this.componentData.ping_ms);
        self.signalQualityColor = this.calcSignalQualityColor(this.componentData.signalToStrength_DB);

        self.sf_mi = this.componentData.sf_mi;
        self.signalToStrength_DB = this.componentData.signalToStrength_DB;
        self.old_action_data.signalToStrength_DB = this.componentData.signalToStrength_DB;
        self.ping_ms = this.componentData.ping_ms;
        self.old_action_data.ping_ms = this.componentData.ping_ms;
        self.download_speed_mb_sec = this.componentData.download_speed_mb_sec;
        self.old_action_data.download_speed_mb_sec = this.componentData.download_speed_mb_sec;
        self.sf_mi_link = this.componentData.sf_mi_link;
        self.tariff = this.componentData.tariff_version;
        self.contract_status = this.componentData.contract_status;
        self.vpp_category = this.componentData.vpp_category;
        self.service_partner_link = this.componentData.service_partner_link;
        self.service_partner = this.componentData.service_partner;
        self.meter_ok = this.componentData.meter_picture_ok;
        self.old_action_data.meter_ok = this.componentData.meter_picture_ok;
        self.circuit_ok = this.componentData.circuit_diagram_ok;
        self.old_action_data.circuit_ok = this.componentData.circuit_diagram_ok;
        this.meterPreparationComment = this.componentData.meterPreparationComment;
        self.old_action_data.meterPreparationComment = this.componentData.meterPreparationComment;
        self.commentForMSB = this.componentData.commentForMSB;
        self.old_action_data.commentForMSB = this.componentData.commentForMSB;
        self.selectedFasteningType_Z1 = this.componentData.fasteningTypeZ1;
        self.old_action_data.selectedFasteningType_Z1 = this.componentData.fasteningTypeZ1;
        self.status_meter_change = this.componentData.status_meter_change;
        self.selectedLanConnection = this.componentData.preparationLanConnection;
        self.old_action_data.selectedLanConnection = this.componentData.preparationLanConnection;
        self.selectedLteConnection = this.componentData.meterConnectionLte;
        self.old_action_data.selectedLteConnection = this.componentData.meterConnectionLte;
        self.meterConnection_ok = this.componentData.meterConnection_ok;
        self.old_action_data.meterConnection_ok = this.componentData.meterConnection_ok;

        self.metering_concept_capable = this.componentData.metering_concept_capable;
        self.asset_created = moment(this.componentData.asset_created).format("YYYY-MM-DD");
        self.jira_task_link = `${this.$appConfig.JIRA_SONNEN_SERVICE_URI}/browse/${this.jira_task}`;

        for (let res in this.componentData.cabinet_image) {
            self.cabinet_image.push(this.componentData.cabinet_image[res]);
        }
        for (let res in this.componentData.circuit_resource) {
            self.circuit_resource.push(this.componentData.circuit_resource[res]);
        }
        for (let res in this.componentData.lan_resources) {
            self.lan_resources.push(this.componentData.lan_resources[res]);
        }
        for (let res in this.componentData.connectivity_resource) {
            self.connectivity_resource.push(this.componentData.connectivity_resource[res]);
        }

        if (typeof self.commentForMSB === "undefined" || self.commentForMSB === null) {
            self.commentForMSB = "";
        }

        if (typeof self.meterPreparationComment === "undefined" || self.meterPreparationComment === null) {
            self.meterPreparationComment = "";
        }
    },
    computed: {
        taskState: function () {
            return this.meter_ok && this.meterConnection_ok;
        },

        fasteningTypeZ1: () => _fasteningType_Z1,
        commentTypes: () => _commentTypes_direct,
        lanConnections: () => _lanConnections,
        lteConnections: () => _lteConnections
    },

    methods: {
        calcMeterConnectionColor: function (status) {
            if (status) {
                return "006400"; //darkgreen
            } else {
                return "DC143C"; //crimson
            }
        },
        calcDownloadSpeedColor: function (speed) {
            if (speed >= 1) {
                return "006400"; //darkgreen
            } else if (speed > 0 && speed < 1) {
                return "DC143C"; //crimson
            } else {
                return "A9A9A9"; //darkgrey
            }
        },
        calcPingColor: function (msec) {
            if (msec > 0 && msec < 50) {
                return "006400"; //darkgreen
            } else if (msec >= 50 && msec <= 100) {
                return "FF7F50"; // coral
            } else if (msec > 100) {
                return "DC143C"; //crimson
            } else {
                return "A9A9A9"; //darkgrey
            }
        },
        calcSignalQualityColor: function (db) {
            if (db < 0 && db >= -100) {
                return "006400"; //darkgreen
            } else if (db < -100 && db >= -105) {
                return "FF7F50"; // coral
            } else if (db < -105) {
                return "DC143C"; //crimson
            } else {
                return "A9A9A9"; //darkgrey
            }
        },
        getCabinetResources: function () {
            return this.cabinet_image;
        },
        getLanResources: function () {
            // TODO: check if resources are no valid URLs
            return this.lan_resources;
        },
        getLteResources: function () {
            return this.connectivity_resource;
        },

        // eslint-disable-next-line no-unused-vars
        submitData: async function (event) {
            Date.prototype.addDays = function (days) {
                var date = new Date(this.valueOf());
                date.setDate(date.getDate() + days);
                return date;
            };

            let task_state = undefined;
            let today = new Date();
            let task_due_date = today.addDays(this.$appConfig.CABINET_CHECK_DUEDATE_SPAN).toISOString().split("T")[0];

            if (this.taskState) {
                task_state = "solve successfully";
            } else {
                task_state = "solve non successfully";
            }
            console.log("task_state", task_state, this.taskState);
            if (this.jira_task && task_state) {
                // update jira task
                changeTaskState(this.jira_task, task_state, this.$session.get("username"), this.$appConfig);
            }
            if (this.jira_task && task_due_date && !this.taskState) {
                changeTaskDueDate(this.jira_task, task_due_date, this.$appConfig);
            }

            const salesforceData = {};
            salesforceData.isCircuitPlanOk = true; // always set to true because is is skipped for direkt2.0

            if (this.old_action_data.meter_ok != this.meter_ok) {
                salesforceData.isMeterCabinetOk = this.meter_ok;
            }

            if (this.old_action_data.commentForMSB != this.commentForMSB) {
                salesforceData.comment_for_msb__c = this.commentForMSB;
            }

            if (this.old_action_data.meterPreparationComment != this.meterPreparationComment) {
                salesforceData.meter_preparation_comment__c = this.meterPreparationComment;
            }

            if (this.old_action_data.meterConnection_ok != this.meterConnection_ok) {
                salesforceData.isMeterConnectionOk = this.meterConnection_ok;
            }
            if (this.old_action_data.selectedLanConnection != this.selectedLanConnection) {
                salesforceData.lanConnectionType = this.selectedLanConnection;
            }
            if (this.old_action_data.selectedLteConnection != this.selectedLteConnection) {
                salesforceData.lteConnectionType = this.selectedLteConnection;
            }

            if (this.old_action_data.selectedFasteningType_Z1 != this.selectedFasteningType_Z1) {
                salesforceData.selectedFasteningType_Z1 = this.selectedFasteningType_Z1;
            }
            if (this.old_action_data.ping_ms != this.ping_ms) {
                salesforceData.ping_ms = this.ping_ms;
            }
            if (this.old_action_data.download_speed_mb_sec != this.download_speed_mb_sec) {
                salesforceData.download_speed_mb_sec = this.download_speed_mb_sec;
            }
            if (this.old_action_data.signalToStrength_DB != this.signalToStrength_DB) {
                salesforceData.signalToStrength_DB = this.signalToStrength_DB;
            }

            if (Object.entries(salesforceData).length > 0 && !this.$appConfig.debug) {
                salesforceData.created = new Date();
                salesforceData.creator = this.$session.get("username");
                await updateSalesforceObject(this.sf_mi, salesforceData, this.$appConfig, (stat) => {
                    console.log("stat", stat);
                    this.updateError = stat;
                });
            } else {
                console.log("DEBUG MODE");
                console.log("... would have sent to SF", salesforceData);
            }
            this.isFinished = true;
        },
        updateCommentType: function (commentType) {
            this.selectedCommentTemplate = commentType;
            if (this.meterPreparationComment.length > 0) {
                this.meterPreparationComment += ";" + commentType;
            } else {
                this.meterPreparationComment = commentType;
            }
        },
        updateFasteningTypeZ1: function (fasteningType) {
            this.selectedFasteningType_Z1 = fasteningType;
        },
        updateLanConnection: function (lanConnection) {
            this.selectedLanConnection = lanConnection;
        },
        updateLteConnection: function (lteConnection) {
            this.selectedLteConnection = lteConnection;
        },
        dropdownShouldOpen_CommentType(VueSelect) {
            if (this.selectedCommentTemplate !== null) {
                return VueSelect.open;
            }

            return VueSelect.search.length !== 0 && VueSelect.open;
        }
    }
};
</script>

<style lang="css" scoped>
#buttons {
    margin-left: 0 !important;
    margin-right: 0 !important;
}
/* Page content */
.content {
    padding: 16px;
}
</style>

<style>
.style-chooser_z1 .vs__search::placeholder,
.style-chooser_z1 .vs__fade-enter-active,
.style-chooser_z1 .vs__fade-leave-active {
    transition: none;
}

.style-chooser_z1 .vs__dropdown-toggle,
.style-chooser_z1 .vs__dropdown-menu {
    background: #dffbef;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
}

.style-chooser_z1 .vs__clear,
.style-chooser_z1 .vs__open-indicator {
    fill: #394066;
}

.style-chooser_comment .vs__search::placeholder,
.style-chooser_comment .vs__fade-enter-active,
.style-chooser_comment .vs__fade-leave-active {
    transition: none;
}

.style-chooser_comment .vs__dropdown-toggle,
.style-chooser_comment .vs__dropdown-menu {
    background: #dcdcd3;
    border: none;
    color: #396653;
    text-transform: lowercase;
    font-variant: small-caps;
}

.style-chooser_comment .vs__clear,
.style-chooser_comment .vs__open-indicator {
    fill: #394066;
}
.style-chooser_network .vs__search::placeholder,
.style-chooser_network .vs__fade-enter-active,
.style-chooser_network .vs__fade-leave-active {
    transition: none;
}

.style-chooser_network .vs__dropdown-toggle,
.style-chooser_network .vs__dropdown-menu {
    background: #f7f6ec;
    border: none;
    color: #396653;
    text-transform: lowercase;
    font-variant: small-caps;
}

.style-chooser_network .vs__clear,
.style-chooser_network .vs__open-indicator {
    fill: #394066;
}
</style>
